import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { SidebarStatuses } from '@atlassian/jira-shared-types/src/issue-sidebar';
import { useSidebarStore } from '@atlassian/jira-software-releases-issue-sidebar-use-sidebar-store/src/controllers';
import { RIGHT_SIDEBAR_WIDTH } from '@atlassian/jira-software-releases-version-detail-shared';
import { SidebarContent } from './sidebar-content';

export const IssueSidebar = () => {
	const [sidebarState] = useSidebarStore();
	const isOpen = sidebarState.status !== SidebarStatuses.CLOSED;

	return isOpen ? (
		<IssueSidebarContainer>
			<SidebarContent />
		</IssueSidebarContainer>
	) : null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueSidebarContainer = styled.div({
	height: '100%',
	position: 'relative',
	padding: `0px 0px ${token('space.200', '16px')} 0px`,
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: `${token('color.background.neutral.subtle', colors.N0)}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${RIGHT_SIDEBAR_WIDTH}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${RIGHT_SIDEBAR_WIDTH}px`,
});
